export var actionablePrimary = "#1F63D2";
export var actionableHover = "#004D99";
export var actionableSecondary = "#0E680E";
export var navigationItemActive = "#1F63D2";
export var navigationItemHover = "#0E680E";
export var semanticPositiveBackground = "#ffffff";
export var backgroundAccentCard = "#ffffff";
//# sourceMappingURL=universal.js.map